import React, { useEffect, useState } from "react";
import TableComponent from "../../components/table/tableComponent";
import { useDispatch } from "react-redux";
import { setChartTitle } from "../../redux/slices/uiSlice";
import "./historicalRiskFactorTable.css";

export default function HistoricalRiskFactorTable({ data }) {
  const dispatch = useDispatch();

  const [isLandscape, setIsLandscape] = useState(
    typeof window !== "undefined"
      ? window.matchMedia("(orientation: landscape)").matches
      : false
  );

  useEffect(() => {
    const mm = window.matchMedia("(orientation: landscape)");
    const onChange = () => setIsLandscape(mm.matches);

    mm.addEventListener?.("change", onChange);
    window.addEventListener("resize", onChange);
    window.addEventListener("orientationchange", onChange);

    return () => {
      mm.removeEventListener?.("change", onChange);
      window.removeEventListener("resize", onChange);
      window.removeEventListener("orientationchange", onChange);
    };
  }, []);

  useEffect(() => {
    if (data?.title) dispatch(setChartTitle(data.title));
  }, [data?.title]);

  if (!data || !data.data || data.data.length === 0) {
    return (
      <div className="chart-content-center">
        <p>No historical risk factor data available</p>
      </div>
    );
  }

  const rows = data.data.map((row, index) => ({
    id: index + 1,
    investment: row.Investment,
    min: row.Min,
    median: row.Median,
    max: row.Max,
  }));

  const columns = [
    { field: "investment", headerName: "Investment", width: 220 },
    {
      field: "min",
      headerName: "Min",
      width: 120,
      type: "number",
      renderCell: (params) => colorCell(params.value),
    },
    {
      field: "median",
      headerName: "Median",
      width: 120,
      type: "number",
      renderCell: (params) => colorCell(params.value),
    },
    {
      field: "max",
      headerName: "Max",
      width: 120,
      type: "number",
      renderCell: (params) => colorCell(params.value),
      disableColumnResize: true,
      flex: 0,
    },
  ];

  return (
    <div className="chart-content-center">
      <div
        className={`table-wrapper ${
          isLandscape ? "is-landscape" : "is-portrait"
        }`}
      >
        <TableComponent rows={rows} columns={columns} />
      </div>
    </div>
  );
}

function colorCell(value) {
  let numericValue = value;

  if (typeof value === "string") {
    numericValue = parseFloat(value.replace("%", ""));
  }
  const color = numericValue < 0 ? "red" : numericValue > 0 ? "green" : "black";

  return <span style={{ color }}>{value}</span>;
}
